/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationStoreYandexGamesYandexBonusSuccessResult } from './FxIdApplicationStoreYandexGamesYandexBonusSuccessResult';
import {
    instanceOfFxIdApplicationStoreYandexGamesYandexBonusSuccessResult,
    FxIdApplicationStoreYandexGamesYandexBonusSuccessResultFromJSON,
    FxIdApplicationStoreYandexGamesYandexBonusSuccessResultFromJSONTyped,
    FxIdApplicationStoreYandexGamesYandexBonusSuccessResultToJSON,
} from './FxIdApplicationStoreYandexGamesYandexBonusSuccessResult';

/**
 * @type FxIdApplicationStoreYandexGamesYandexBonusResultDataSucccessData
 * 
 * @export
 */
export type FxIdApplicationStoreYandexGamesYandexBonusResultDataSucccessData = FxIdApplicationStoreYandexGamesYandexBonusSuccessResult;

export function FxIdApplicationStoreYandexGamesYandexBonusResultDataSucccessDataFromJSON(json: any): FxIdApplicationStoreYandexGamesYandexBonusResultDataSucccessData {
    return FxIdApplicationStoreYandexGamesYandexBonusResultDataSucccessDataFromJSONTyped(json, false);
}

export function FxIdApplicationStoreYandexGamesYandexBonusResultDataSucccessDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationStoreYandexGamesYandexBonusResultDataSucccessData {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationStoreYandexGamesYandexBonusSuccessResult(json)) {
        return FxIdApplicationStoreYandexGamesYandexBonusSuccessResultFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationStoreYandexGamesYandexBonusResultDataSucccessDataToJSON(json: any): any {
    return FxIdApplicationStoreYandexGamesYandexBonusResultDataSucccessDataToJSONTyped(json, false);
}

export function FxIdApplicationStoreYandexGamesYandexBonusResultDataSucccessDataToJSONTyped(value?: FxIdApplicationStoreYandexGamesYandexBonusResultDataSucccessData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationStoreYandexGamesYandexBonusSuccessResult(value)) {
        return FxIdApplicationStoreYandexGamesYandexBonusSuccessResultToJSON(value as FxIdApplicationStoreYandexGamesYandexBonusSuccessResult);
    }

    return {};
}

